module.exports = __webpack_public_path__ + "static/media/w_b_18.632cc6db.png";